(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-obs-pairs-with"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var el = document.querySelector('.hh-pairs-with[data-product-id]');
    if (!el) return;
    var pid = el.dataset.productId;
    if (!pid) return;
    var tm = { 'obs-product-movement-tray': 'MOVEMENT TRAY', 'obs-product-converter': 'CONVERTER', 'obs-product-base': 'BASE' };
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var p = d.products;
        if (!p || !p.length) return;
        var g = el.querySelector('.hh-pairs-with__grid');
        p.forEach(function(x) {
          var cat = 'OBS';
          if (x.tags) {
            var t = Array.isArray(x.tags) ? x.tags : x.tags.split(', ');
            for (var k in tm) { if (t.indexOf(k) !== -1) { cat = tm[k]; break; } }
          }
          var im = x.featured_image ? '<img src="' + x.featured_image.replace(/\.([a-z]+)$/, '_300x.$1') + '" alt="' + (x.title||'').replace(/"/g,'&quot;') + '" loading="lazy" width="300" height="300">' : '';
          var pr = x.price ? (x.price/100).toFixed(2) : '';
          var pf = x.price_varies ? 'From ' : '';
          var c = document.createElement('a');
          c.href = x.url;
          c.className = 'hh-pairs-with__card';
          c.innerHTML = '<p class="hh-pairs-with__cat">' + cat + '</p><div class="hh-pairs-with__media">' + im + '</div><div class="hh-pairs-with__body"><p class="hh-pairs-with__title">' + x.title + '</p>' + (pr ? '<p class="hh-pairs-with__price">' + pf + '£' + pr + '</p>' : '') + '<span class="hh-pairs-with__cta">View product →</span></div>';
          g.appendChild(c);
        });
        /* Width comes from the §28 sheet-box formula in hh-custom.css
           (2026-07-25) — no JS width hint (an inline width would beat the
           CSS box and the old .hh-base-info__stack reference is gone). */
        el.style.display = 'block';
      }).catch(function(){});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
